// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/cruise-performance-charts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/cruise-performance-charts/cruise-performance-charts.js';

mount([g0]);
